// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invite-shareplan ul{margin-left:1em;list-style-type:disc}.invite-shareplan ul li{display:list-item}", ""]);
// Exports
module.exports = exports;
